module.exports = __webpack_public_path__ + "1.5.0-unryo/img/victorops.4500f8af.png";